import { c as _c } from "react/compiler-runtime";
import { IconKey } from "@tabler/icons-react";
import React from "react";
import { useTranslations } from "next-intl";
import { ErrorComponent } from "@components/errors/error-component";
import { NavUserLogin } from "@features/auth/ui/nav-user-login";
export const NotLogged = () => {
  const $ = _c(8);
  const t = useTranslations("common.errors");
  let t0;
  if ($[0] !== t) {
    t0 = t("notLogged.subTitle");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("notLogged.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavUserLogin />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = <ErrorComponent icon={IconKey} subTitle={t0} description={t1} externalNodes={t2} homeLinkDisabled={true} backLinkDisabled={true} />;
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};